import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class LuckyDrawService {


    static getLuckyDraw(item) {

        const {
            page = 1,
            limit = 10,
            id = ""
        } = item || {};

        let api =
            `${API_BASE_URL}${API_PATHS.getluckydraw}` +
            `?page=${page}&limit=${limit}`;

        // Optional pageId append
        if (id) {
            api += `&id=${id}`;
        }

        return axiosInstance.get(api);
    }

    static myluckydraw(item) {

        const {
            page = 1,
            limit = 10,
            id = ""
        } = item || {};

        let api =
            `${API_BASE_URL}${API_PATHS.myluckydraw}` +
            `?page=${page}&limit=${limit}`;

        // Optional pageId append
        if (id) {
            api += `&id=${id}`;
        }

        return axiosInstance.get(api);
    }

    static addLuckydraw(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addLuckydraw}`;
        return axiosInstance
            .post(api, item)

    }


    // getuserluckydraw --- > 
    static getUserLuckyDraw(item) {

        const {
            id = ""
        } = item || {};

        let api =
            `${API_BASE_URL}${API_PATHS.getuserluckydraw}`;

        // Optional pageId append
        if (id) {
            api += `&id=${id}`;
        }

        return axiosInstance.get(api);
    }

    static getluckydrawentries(item) {

        const {
            page = 1,
            limit = 10,
            id = ""
        } = item || {};

        let api =
            `${API_BASE_URL}${API_PATHS.getluckydrawentries}` +
            `?page=${page}&limit=${limit}`;

        // Optional pageId append
        if (id) {
            api += `&id=${id}`;
        }

        return axiosInstance.get(api);
    }


    static approveluckydrawentry(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.approveluckydrawentry}`;

        return axiosInstance.post(api, item)
    }


    // join user call draw ---------- > 
    static JoinLuckyDraw(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.joinluckydraw}`;

        return axiosInstance.post(api, item)
    }





    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) : "";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default LuckyDrawService;
